import type { Stroke } from '../../../types';
import type { DrawShape } from '../../draw/shapes';
import type { Connector } from '../shapes/Connector';
import type { Shape } from '../shapes/Shape';
import type { TextElement } from '../shapes/TextElement';
import type { UnifiedStore } from '../../unified/UnifiedStore';

export class DiagramStore {
  private readonly unifiedStore: UnifiedStore;

  constructor(unifiedStore: UnifiedStore) {
    this.unifiedStore = unifiedStore;
  }

  get shapes(): Shape[] {
    return this.unifiedStore.shapes;
  }

  set shapes(value: Shape[]) {
    this.unifiedStore.shapes = value;
  }

  get connectors(): Connector[] {
    return this.unifiedStore.connectors;
  }

  set connectors(value: Connector[]) {
    this.unifiedStore.connectors = value;
  }

  get textElements(): TextElement[] {
    return this.unifiedStore.textElements;
  }

  set textElements(value: TextElement[]) {
    this.unifiedStore.textElements = value;
  }

  get selectedElements(): Set<string> {
    return this.unifiedStore.selectedElements;
  }

  set selectedElements(value: Set<string>) {
    this.unifiedStore.selectedElements = value;
  }

  get drawShapes(): DrawShape[] {
    return this.unifiedStore.drawShapes;
  }

  get strokes(): Stroke[] {
    return this.unifiedStore.strokes;
  }
}
